export default {
  methods: {
    mapLayerSatSummer2014Add () {
      this.map.addSource('sat-2014-40cm-tiles', {
        type: 'raster',
        tiles: ['https://d1dsfrg9q75324.cloudfront.net/{z}/{x}/{y}.png'],
        tileSize: 256
      })

      this.map.addLayer({
        id: 'sat-2014-40cm-tiles',
        type: 'raster',
        source: 'sat-2014-40cm-tiles',
        layout: {
          visibility: 'visible'
        }
      })

      this.map.moveLayer('sat-2014-40cm-tiles', 'marker-layer-bottom')
    },
    mapLayerSatSummer2014Remove () {
      this.map.removeLayer('sat-2014-40cm-tiles')
      this.map.removeSource('sat-2014-40cm-tiles')
    }
  },
  watch: {
    '$store.state.toggle.imagry.summer_2014_40cm': function (newValue, oldValue) {
      if (newValue === true) {
        this.mapLayerSatSummer2014Add()
      } else {
        this.mapLayerSatSummer2014Remove()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/imagry/satSummer2014.js